// extracted by mini-css-extract-plugin
export var editButton = "styles-module__editButton___QOMk1";